<template>
  <div :class="{'lt-lg': minimized, 'gt-md': !minimized}">
    <posts-toolbar-btn
      v-if="minimized"
      :filters="filters"
      v-bind="maximizeBtn"
      @update:filters="$emit('update:filters', $event)"
    >
      <slot />
    </posts-toolbar-btn>
    <posts-toolbar
      v-else
      :filters="filters"
      @update:filters="$emit('update:filters', $event)"
    >
      <slot />
      <template v-slot:append><slot name="append" /></template>
    </posts-toolbar>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostFilters } from '@/type';
import PostsToolbar from './PostsToolbar.vue';
import PostsToolbarBtn from './PostsToolbarBtn.vue';

export default defineComponent({
  emits: ['update:filters'],
  components: {
    PostsToolbarBtn,
    PostsToolbar,
  },
  props: {
    filters: {
      type: Object as () => PostFilters,
      required: true,
    },
    minimized: {
      type: Boolean,
      default: false,
    },
    maximizeBtn: Object,
  },
});
</script>
